import { motion } from "framer-motion";
import { Instagram, Facebook, MessageCircle, Phone, Mail, Star, QrCode } from "lucide-react";
import { BRAND } from "../../data/menu";

const REVIEW_URL =
  "https://www.google.com/maps/search/?api=1&query=Puneri+Kitchen+Garudacharpalya+Bangalore";

export default function Connect() {
  const links = [
    { Icon: Instagram, label: "Follow on Instagram", sub: `@${BRAND.instagram}`, href: `https://instagram.com/${BRAND.instagram}`, tid: "connect-instagram" },
    { Icon: Facebook, label: "Like on Facebook", sub: BRAND.facebook, href: BRAND.facebookUrl, tid: "connect-facebook" },
    { Icon: MessageCircle, label: "Chat on WhatsApp", sub: BRAND.phone, href: `https://wa.me/${BRAND.phoneRaw}`, tid: "connect-whatsapp" },
    { Icon: Phone, label: "Call Us", sub: BRAND.phone, href: `tel:${BRAND.phone.replace(/\s/g, "")}`, tid: "connect-call" },
    { Icon: Star, label: "Leave a Review", sub: "on Google", href: REVIEW_URL, tid: "connect-review" },
    { Icon: Mail, label: "Email Us", sub: BRAND.email, href: `mailto:${BRAND.email}`, tid: "connect-email" },
  ];

  return (
    <section id="connect" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 md:px-8 grid lg:grid-cols-[0.85fr_1.15fr] gap-14 items-center">
        {/* QR */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex justify-center"
        >
          <div className="rounded-[28px] bg-[#f7f0e0] ring-1 ring-[#7a1f1f]/15 shadow-[0_20px_60px_rgba(122,31,31,0.12)] p-5 md:p-6 max-w-[320px]">
            <img
              src={`${process.env.PUBLIC_URL || ""}/qr-social.png`}
              alt="Scan to follow Puneri Kitchen"
              data-testid="connect-qr"
              className="w-full h-auto rounded-2xl"
            />
            <p className="mt-3 text-center text-sm font-medium text-[#5c3a3a]">
              Point your camera &amp; scan
            </p>
          </div>
        </motion.div>

        {/* Copy + links */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <div className="flex items-center gap-3 mb-4">
            <QrCode className="text-[#d97706]" size={22} />
            <p className="text-sm uppercase tracking-[0.3em] font-bold text-[#d97706]">Stay Connected</p>
          </div>
          <h2 className="font-display text-5xl md:text-6xl font-bold tracking-tight text-[#331818] leading-none">
            Scan. Follow. <span className="italic font-accent text-[#7a1f1f]">Savour.</span>
          </h2>
          <p className="mt-5 max-w-md text-lg text-[#5c3a3a] leading-relaxed">
            One scan connects you to everything Puneri Kitchen — follow us on
            social media, drop a review, and reach us in a tap.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            {links.map(({ Icon, label, sub, href, tid }) => (
              <a
                key={tid}
                data-testid={tid}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="group flex items-center gap-4 rounded-2xl bg-[#f7f0e0] ring-1 ring-[#7a1f1f]/15 px-4 py-3.5 transition-colors duration-300 hover:ring-[#d97706] hover:bg-[#eae0c9]/60"
              >
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#7a1f1f] text-[#f7f0e0] transition-colors duration-300 group-hover:bg-[#d97706]">
                  <Icon size={18} />
                </span>
                <span className="flex flex-col leading-tight">
                  <span className="font-semibold text-[#331818]">{label}</span>
                  <span className="text-sm text-[#5c3a3a]">{sub}</span>
                </span>
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
